/**
 * Contenido de bases y condiciones del sorteo (público).
 * Solo copy UX; no afecta backend.
 */

export const SORTEO_MAPS_URL =
  "https://maps.app.goo.gl/jSGW3Bxvv4GPDkTy5?g_st=ic";

export const SORTEO_LOCATION_ADDRESS =
  "Calle Cañada Larga #2170, barrio Lazareto, frente a la cancha de fútbol.";

export const SORTEO_BASES_META = {
  title: "🏍️ ¡GÁNATE UNA MOTOCICLETA GRATIS!",
  subtitle: "DEL 10 DE SEPTIEMBRE AL 19 DE NOVIEMBRE DE 2026 🎉",
  sectionTitle: "BASES Y CONDICIONES — PROTEIN BAR MR. QUILLO",
};

/**
 * @typedef {{ number: number, title: string, paragraphs?: string[], intro?: string, bullets?: string[], outro?: string }} SorteoBasesSection
 * @type {SorteoBasesSection[]}
 */
export const SORTEO_BASES_SECTIONS = [
  {
    number: 1,
    title: "Participación",
    paragraphs: [
      "La participación en esta promoción es totalmente gratuita y no requiere realizar ninguna compra, consumo, pago, afiliación ni adquisición de productos o servicios.",
      "Podrán participar exclusivamente personas mayores de 18 años, que cumplan con los requisitos establecidos en estas bases.",
    ],
  },
  {
    number: 2,
    title: "¿Cómo participar?",
    intro: "Para participar, la persona deberá:",
    bullets: [
      "Descargar la aplicación habilitada para la promoción.",
      "Registrarse gratuitamente.",
      "Obtener su código o número personal de participación.",
      "Presentar dicho código en Protein Bar Mr. Quillo durante el período de vigencia de la promoción.",
      "Recibir su participación física correspondiente para depositarla en la urna habilitada.",
    ],
    outro:
      "También se puede participar rellenando el cupón de participación y presentándolo directamente en Protein Bar Mister Quillo.",
  },
  {
    number: 3,
    title: "Participación gratuita y sin compra",
    paragraphs: [
      "La participación es gratuita.",
      "No se comercializan boletos ni números de participación.",
      "La compra o consumo de productos en Protein Bar Mr. Quillo no es requisito para participar y no otorga participaciones adicionales ni aumenta las posibilidades de resultar ganador.",
    ],
  },
  {
    number: 4,
    title: "Vigencia",
    paragraphs: [
      "La promoción estará vigente desde el 10 de septiembre de 2026 hasta el 19 de noviembre de 2026.",
      "Las participaciones deberán ser obtenidas y depositadas dentro del período establecido.",
    ],
  },
  {
    number: 5,
    title: "🗓️ GRAN SORTEO",
    paragraphs: [
      "📅 20 de noviembre de 2026",
      "⏰ 19:00 horas",
      "📍 Protein Bar Mr. Quillo",
      "El sorteo se realizará mediante un procedimiento aleatorio entre las participaciones válidas, ante Notario de Fe Pública, según corresponda, y será transmitido en vivo a través del TikTok oficial de Mr. Quillo.",
    ],
  },
  {
    number: 6,
    title: "🏆 Determinación y anuncio del ganador",
    paragraphs: [
      "El ganador será determinado mediante el procedimiento de sorteo establecido en estas bases.",
      "Su nombre será anunciado durante la transmisión y posteriormente podrá ser comunicado a través de los canales oficiales de Mr. Quillo y en un lugar visible del establecimiento.",
    ],
  },
  {
    number: 7,
    title: "📄 Reclamo del premio",
    paragraphs: [
      "El ganador dispondrá de 15 días calendario desde la comunicación oficial del resultado para reclamar el premio, presentando su documento de identidad y cumpliendo los requisitos necesarios para acreditar su identidad.",
      "En caso de que el ganador no reclame el premio dentro del plazo establecido, se procederá conforme a las disposiciones legales y reglamentarias que resulten aplicables, incluyendo, cuando corresponda, la realización de un nuevo sorteo.",
    ],
  },
  {
    number: 8,
    title: "🏍️ Documentación de la motocicleta",
    paragraphs: [
      "La motocicleta será entregada conforme a las características publicadas en la promoción.",
      "El ganador recibirá la documentación correspondiente a la motocicleta y la factura o documento de transferencia que legalmente corresponda.",
      "Los gastos, trámites, impuestos, seguros, placa, SOAT, B-SISA u otros conceptos asociados a la puesta en circulación del vehículo que no estén expresamente incluidos en el premio serán responsabilidad del ganador, cuando legalmente corresponda.",
    ],
  },
  {
    number: 9,
    title: "🎟️ Participaciones no válidas",
    intro: "Serán anuladas las participaciones que:",
    bullets: [
      "Presenten alteraciones o falsificaciones.",
      "Sean duplicadas.",
      "No correspondan al sistema de registro establecido.",
      "Contengan información manifiestamente falsa o incompleta.",
      "No cumplan estas bases y condiciones.",
    ],
  },
  {
    number: 10,
    title: "📲 Canal de WhatsApp",
    paragraphs: [
      "Los participantes podrán unirse voluntariamente al canal oficial de difusión de WhatsApp: “Mister Quillo Sorteo Moto y Promociones” para recibir novedades e información relacionada con la promoción.",
      "La incorporación al canal no constituye un requisito para participar.",
    ],
  },
  {
    number: 11,
    title: "📞 Consultas",
    paragraphs: [
      "Para obtener información sobre la promoción:",
      "📞 67816517",
      "o directamente en:",
      "📍 Protein Bar Mr. Quillo",
    ],
  },
  {
    number: 12,
    title: "🔒 Datos personales",
    paragraphs: [
      "Los datos proporcionados por los participantes serán utilizados para gestionar su participación en la promoción, comunicarse con el ganador y realizar las actuaciones necesarias relacionadas con el sorteo, de acuerdo con la normativa aplicable.",
    ],
  },
  {
    number: 13,
    title: "✅ Aceptación",
    paragraphs: [
      "La participación en esta promoción implica la aceptación de estas Bases y Condiciones.",
      "La organización se reserva el derecho de realizar las aclaraciones o modificaciones que sean necesarias para garantizar el correcto desarrollo de la promoción, siempre dentro de la normativa aplicable y comunicándolas por los medios correspondientes.",
    ],
  },
];
